import { createPopper } from "@popperjs/core";

export class TooltipElement extends HTMLElement {
    private _shadowRoot: ShadowRoot;
    private p: any;

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
        this._shadowRoot.innerHTML = "<style>:host{z-index:101;}</style><s6-tooltip-body></s6-tooltip-body>";
    }

    static get observedAttributes() { return ["data-popper-placement"]; }
    public attributeChangedCallback(name, oldValue, newValue) {
        this._shadowRoot.querySelector("s6-tooltip-body").setAttribute("data-popper-placement", this.getAttribute("data-popper-placement"));
    }
    public set element(element) {
        if (element == null) {
            if (this.p == null) {
                return;
            }
            this.p.destroy();
            this.p = null;
            document.body.removeChild(this);
        } else {
            this._shadowRoot.querySelector("s6-tooltip-body").innerHTML = element.getAttribute("data-tip");
            this.p = createPopper(element, this, {
                placement: "bottom-start",
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [0, 8],
                        },
                    },
                ],
            });
        }
    }
}

export function initTooltipWebDataTipComponent() {
    window.customElements.define("s6-tooltip-data-tip", TooltipElement);
}
